import store from '../store/store';
import { getMailboxForwardingConfiguration } from 'owa-forwarding-configuration';
import { getFallbackValueIfNull } from 'owa-options-core';

/**
 * Returns the current value of the "Keep a copy" checkbox.
 * @returns The value of the checkbox
 */
export default function getKeepCopy(): boolean {
    const forwardingConfiguration = getMailboxForwardingConfiguration();
    const optionState = store;

    return getFallbackValueIfNull(
        optionState.keepCopy,
        forwardingConfiguration.DeliverToMailboxAndForward
    );
}
